import React from 'react'
import { IconInformation, IconLockLocked } from '@yoti/ui-kit-components-react/icons'
import { t, Trans } from '@lingui/macro'

import StickyNote from '../common/StickyNote'
import LocalisedImage from '../common/LocalisedImage'
import detailsSafe from '../../../assets/your-details-safe.png'
import withRelativeContentHeight from '../../hoc/withRelativeContentHeight'

import './DetailsSafe.scss'

const WHITE = '#fff'

const DETAILS_SAFE_HEADING = t`Your details are safe`
const DETAILS_SAFE_DESCRIPTION = t`
  Any details you add to your Digital ID are encrypted into unreadable data, split up and safely stored in our database.
  Only you have the key to unlock your encrypted details, which is stored safely in your phone, not in our database.
`
const DETAILS_SAFE_INFORMATION = t`
  Our systems are built in a way that means we cannot mine or sell your data to third parties. 
  Once we’ve completed our security checks, we can’t access any of your personal details. 
  We can’t send your details to a business or individual until you choose to send them.
`


export const DetailsSafeMainPanel = () => (
  <div className="details-safe__main-panel">

    <div className="details-safe__main-panel__content">
      <div className="details-safe__main-panel__content__header">
        <div className="details-safe__main-panel__content__header__icon-wrapper">
          {/* <Icon className="details-safe__main-panel__content__header__icon-wrapper__icon" component={lockLocked} /> */}
          <IconLockLocked />
        </div>
        <h6 className="details-safe__main-panel__content__header__text">
          <Trans id={DETAILS_SAFE_HEADING} />
        </h6>
      </div>
      <div className="details-safe__main-panel__content__text">
        <p>
          <Trans id={DETAILS_SAFE_DESCRIPTION} />
        </p>
      </div>
    </div>
    <div className="details-safe__main-panel__visual">
      <LocalisedImage className="details-safe__main-panel__visual__image-wrapper" src={detailsSafe} alt={DETAILS_SAFE_HEADING} />
    </div>
  </div>
)

export const DetailsSafeExtraPanelBase = () => (
  <div className="details-safe__extra-panel">
    <StickyNote icon={<IconInformation />} bgColor={WHITE}>
      <p>
        <Trans id={DETAILS_SAFE_INFORMATION} />
      </p>
    </StickyNote>
  </div>
)

export const DetailsSafeExtraPanel = withRelativeContentHeight(DetailsSafeExtraPanelBase, 50)


const DetailsSafe = () => (
  <div className="details-safe">
    <DetailsSafeMainPanel />
    <DetailsSafeExtraPanel />
  </div>
)

export default DetailsSafe
